import { Typography } from "@mui/material";
import clsx from "clsx";
import React, { useEffect, useState } from "react";
import { makeStyles } from "@mui/styles";
import FuseSvgIcon from "@fuse/core/FuseSvgIcon/FuseSvgIcon";
import { Link, useLocation, useParams } from "react-router-dom";
import jwtDecode from "jwt-decode";

const useStyles = makeStyles((theme) => ({
  root: {
    borderTop: `1px solid rgba(241,245,249,.12)`,
    borderBottom: `1px solid rgba(241,245,249,.12)`,
    padding: "15px 0",

    "& li": {
      padding: "0 25px",
      textAlign: "center",

      "& svg": {
        margin: "auto",
      },
      "& a": {
        color: `${theme.palette.common.white} !important`,
        textDecoration: 'none !important'
      }
    },
    "& li.active": {
      color: `${theme.palette.primary.main}`,
    },
    "& li.preview": {
      opacity: "0.4",
    },
  },
}));

export default function Progress(props) {
  const { id } = useParams()
  const classes = useStyles(props);
  const location = useLocation();
  const [url, setUrl] = useState(null);
  const [partner, setPartner] = useState(false);
  useEffect(() => {
    setUrl(location.pathname);
  }, [location]);


  useEffect(() => {
    const token = (localStorage && localStorage.getItem('token')) && jwtDecode(localStorage.getItem('token'));
    const currentUser = token?.email;
    const currentUserRoles = token?.scope;
    if(currentUserRoles && currentUserRoles?.includes('ROLE_PARTNER_ADMIN')){
      setPartner(true);
    }
  }, []);
  return (
    <div className={clsx(classes.root)}>
      <ul className="flex items-end">
        <li className={[props.currentStep === 1 ? 'active' : props.currentStep > 1 ? 'preview' : null]}>
          <Link to={`/design-studio/showroom-questionnaire/${id}`}>
            <span>
              { props.currentStep === 1 ? <FuseSvgIcon size={24}>heroicons-outline:check-check</FuseSvgIcon> : props.currentStep > 1 ? <FuseSvgIcon size={24}>heroicons-outline:check-circle</FuseSvgIcon> : <></>}
            </span>
            <Typography variant="body">Request Brief</Typography>
          </Link>
        </li>
        <li
          className={[props.currentStep === 2 ? 'active' : props.currentStep > 2 ? 'preview' : null]}
        >
          <Link to={`/design-studio/request-review/${id}`}>
            <span>{props.currentStep === 2 ? <FuseSvgIcon size={24}>heroicons-outline:check</FuseSvgIcon> : props.currentStep > 2 ? <FuseSvgIcon size={24}>heroicons-outline:check-circle</FuseSvgIcon> : <></>}</span>
            <Typography variant="body">Review</Typography>
          </Link>
        </li>
        {!partner && props.category === 'SHR' && <li className={[props.currentStep === 3 ? 'active' : props.currentStep > 3 ? 'preview' : null]}>
          <Link to={`/design-studio/space-planing/${id}`}>
            <span>{props.currentStep === 3 ? <FuseSvgIcon size={24}>heroicons-outline:check</FuseSvgIcon> : props.currentStep > 3 ? <FuseSvgIcon size={24}>heroicons-outline:check-circle</FuseSvgIcon> : <></>}</span>
            <Typography variant="body">Space planning</Typography>
          </Link>
        </li>}
        {props.category === 'SHR' && <li
          className={[props.currentStep === 4 ? 'active' : props.currentStep > 4 ? 'preview' : null]}
        >
          <Link to={`/design-studio/space-planing-review/${id}`}>
            <span>{props.currentStep === 4 ? <FuseSvgIcon size={24}>heroicons-outline:check</FuseSvgIcon> : props.currentStep > 4 ? <FuseSvgIcon size={24}>heroicons-outline:check-circle</FuseSvgIcon> : <></>}</span>
            <Typography variant="body">{partner ? 'Space Planning Review' : 'Review'}</Typography>
          </Link>
        </li>}
        {!partner && <li
          className={[props.currentStep === 5 ? 'active' : props.currentStep > 5 ? 'preview' : null]}
        >
          <Link to={`/design-studio/individual-kitchen-design/${id}`}>
            <span>{props.currentStep === 5 ? <FuseSvgIcon size={24}>heroicons-outline:check</FuseSvgIcon> : props.currentStep > 5 ? <FuseSvgIcon size={24}>heroicons-outline:check-circle</FuseSvgIcon> : <></>}</span>
            <Typography variant="body">Individual Kitchen Design</Typography>
          </Link>
        </li>}
        <li
          className={[props.currentStep === 6 ? 'active' : props.currentStep > 6 ? 'preview' : null]}
        >
          <Link to={`/design-studio/individual-kitchen-design-review/${id}`}>
            <span>{props.currentStep > 6 ? <FuseSvgIcon size={24}>heroicons-outline:check</FuseSvgIcon> : props.currentStep > 6 ? <FuseSvgIcon size={24}>heroicons-outline:check-circle</FuseSvgIcon> : <></>}</span>
            <Typography variant="body">{partner ? 'Individual Kitchen Design Review' : 'Review'}</Typography>
          </Link>
        </li>
      </ul>
    </div>
  );
}
